import { Theme, Box, Link, SxProps } from "@mui/material";
import {
  CalendarMonth,
  CalendarMonthOutlined,
  Feed,
  FeedOutlined,
  Person,
  PersonOutlined,
  ResetTv,
  SvgIconComponent,
  TvOutlined,
} from "@mui/icons-material";
import React from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import { useUserState } from "../../services/backend";
import { links } from "../../constants";
import { UserState } from "src/services/rpc-client";
import permissionManager, { Attributes } from "@lib/permission";

interface AppBarNavLink {
  to: string;
  name: string;
  Icon: SvgIconComponent;
  ActiveIcon: SvgIconComponent;
  /** default is match.isExact */
  // isActive?: NavLinkProps["isActive"];
  isActive?: (path: string) => boolean;
  hasNew?: (o?: UserState) => boolean;
  r?: Attributes;
}

const navLinks: AppBarNavLink[] = [
  {
    name: "Libraries",
    to: links.folders,
    Icon: TvOutlined,
    ActiveIcon: ResetTv,
    isActive: (path) => Boolean(path.startsWith("/d") && !path.startsWith("/d/item/")),
  },
  { name: "Actors", to: links.people, Icon: PersonOutlined, ActiveIcon: Person },
  {
    name: "Feed",
    to: links.feed,
    Icon: FeedOutlined,
    ActiveIcon: Feed,
    hasNew: (o) => o?.has_unseen_feed || false,
  },
  {
    name: "Calendar",
    to: links.calendar,
    Icon: CalendarMonthOutlined,
    ActiveIcon: CalendarMonth,
  },
  // {
  //   name: "Manage",
  //   to: links.manage,
  //   Icon: SettingsOutlined,
  //   ActiveIcon: Settings,
  //   r: "edit_site_data",
  // },
];

const linkSxProps: SxProps<Theme> = (theme) => ({
  padding: theme.spacing(0, 0, 0, 1),
  textDecoration: "none",
  color: theme.palette.primary.dark, //"#e75480",
  fontWeight: "bold",
  position: "relative",
  letterSpacing: theme.typography.caption.letterSpacing,
  [theme.breakpoints.down("sm")]: {
    borderBottom: "#5b5c5d solid 0.5px",
    padding: `${theme.spacing(0.5, 1.5, 1, 1.5)} !important`, // important so &:first-child padding 0 doesn't get used at this breakpoint
  },
  // "&:first-of-type": { padding: 0 },
  "&:last-child": { borderBottom: "inherit" },
});

export const AppBarNavLinksDesktop = () => {
  const { data: userState } = useUserState();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1, padding: (t) => t.spacing(0, 1) }}>
      {navLinks.map((link) => (
        <SiteLink key={`APPBAR_NAVLINK_${link.to}`} link={link} userState={userState} />
      ))}
    </Box>
  );
};

type SiteLinkProps = {
  link: AppBarNavLink;
  userState?: UserState;
  isMobile?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
};
export const SiteLink = ({ link, userState, onClick, style, isMobile }: SiteLinkProps) => {
  const match = useRouteMatch(link.to || "");

  if (link.r && !permissionManager.userCanAccess(link.r)) {
    return <></>;
  }

  const isActive = link.isActive ? link.isActive(window.location.pathname) : match?.isExact;

  const Icon = isActive ? link.ActiveIcon : link.Icon;

  return (
    <Link
      to={link.to}
      component={NavLink}
      onClick={onClick}
      sx={linkSxProps}
      activeClassName={"link-active"}
      style={style}
      // isActive={link.isActive ? link.isActive : (a: any) => a?.isExact || false}
      isActive={() => isActive || false}
    >
      <Icon style={{ top: 3, position: "relative" }} /> {link.name}
      {(link.hasNew && link.hasNew(userState) && <NewIndicator style={{ right: isMobile ? "inherit" : undefined }} />) || ""}
    </Link>
  );
};

const NewIndicator = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <Box
      style={style}
      position="absolute"
      bgcolor="red"
      height={8}
      width={8}
      right={-2}
      top={3}
      zIndex={10}
      color={"red"}
      borderRadius="100%"
    />
  );
};
